import {Component, Inject, LOCALE_ID, OnDestroy, OnInit, signal} from '@angular/core';
import {AisCommonService, AuthService, HeaderAction, HeaderMenuLink, UserInfo} from 'ais-common';
import {TranslateService} from '@ngx-translate/core';
import {filter, Subscription} from 'rxjs';
import {AppService} from './app.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Upozornenie} from './model/Upozornenie';
import {UpozorneniaComponent} from './upozornenia/upozornenia.component';
import {HttpParams} from '@angular/common/http';
import {Config} from './model/Config';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'student-predmety';

    userInfo: UserInfo;
    userName = '';
    private userInfoSubscription: Subscription;
    aisUrl = '';
    headerActions: HeaderAction[] = [];
    public upozornenia: Upozornenie[] = [];
    private upozorneniaSubscription = new Subscription();
    public httpParams: HttpParams = new HttpParams();
    private zapisnyListChange = new Subscription();
    red = false;

    private config: Config;

    protected readonly isMobile = signal(window.innerWidth < 1180);
    activeTabTitle: 'noname';
    message: string;

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        private authService: AuthService,
        public translate: TranslateService,
        private appCommonService: AisCommonService,
        private appService: AppService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        translate.use(locale);
    }

    ngOnInit(): void {

        const lng = this.locale.toLowerCase();

        this.aisUrl = '/ais/apps/student/{lng}'.replace('{lng}', lng);

        this.route.queryParamMap.subscribe(queryParams => {
            this.appService.setIdZapisnyList(
                Number(queryParams.get('zl'))
            );
        });

        this.authService.initAccessTokenSession();

        this.translate.get('student-predmety')
            .subscribe((value) => {
                this.title = value;
            });

        this.userInfoSubscription =
            this.appCommonService.userInfoSubject.subscribe(
                (userInfo) => {
                    this.userInfo = userInfo;
                    this.userName = userInfo.fullName;
                    this.red = (userInfo.oj === 'UK');
                    this.appService.setRed(this.red);
                }
            );

        this.headerActions = [];

        this.headerActions.push(
            new HeaderMenuLink('AiS2',
                '/ais/apps/student/{lng}'.replace('{lng}', lng),
                'arrow_back'
            )
        );

        this.appCommonService.fetchUserInfo();

        this.appService.fetchZapisneListy();

        this.upozorneniaSubscription = this.appService.upozorneniaSubject
            .subscribe((data) => {
                this.upozornenia = data;
            });

        this.upozornenia = this.appService.getUpozornenia();

        this.zapisnyListChange = this.appService.zapisnyListSubject
            .subscribe((zl) => {
                if (zl && zl.id) {
                    this.httpParams = this.httpParams.set('zl', zl.id.toString());
                }
            });


        this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => {
                const child = this.route.root.firstChild;
                this.activeTabTitle = child?.snapshot.data.title || '';
            });
    }

    ngOnDestroy(): void {
        this.userInfoSubscription.unsubscribe();
        this.zapisnyListChange.unsubscribe();
    }

    openWarnings() {
        this.appService.openDialog(UpozorneniaComponent);
    }
}

